import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageMeta } from './PageMeta'
import { NotificationDto } from './NotificationDto'
/**
* Class PageOfNotificationDto
*  Результат постраничного запроса
*/
export class PageOfNotificationDto extends ActiveModel {

  /**
  * meta
  * Meta-информация о результате постраничного запроса  */
  @ActiveField({
    factory: [PageMeta, () => undefined]
  })
  meta?: PageMeta


/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [NotificationDto, () => undefined]
  })
  items?: Array<NotificationDto>
}
